// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js!../../input/style/index.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../../../node_modules/css-loader/dist/cjs.js!../../common_style/arrow_button.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =============================================================================
    overwrite base input style
   ===========================================================================*/
.swiftref-input swiftref-icon {
    position: absolute;
    top: calc(var(--spacing-15) + 1px);
    right: var(--spacing-10);
    left: unset;
    width: fit-content;
}
.swiftref-input .clear-icon {
    right: var(--spacing-30);
}
/*:host(:not([message]) .swiftref-input swiftref-message {*/
/*    margin-top: 0;*/
/*    display: none;*/
/*}*/


/* =============================================================================
    time_input style
   ===========================================================================*/

:host {
    display: inline-block;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
    position: relative;
}

.timepicker-container {
    position: relative;
}


.timepicker-panel {
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 10;
    background: var(--background-default);
    border: 1px solid var(--border-light);
    border-radius: 4px;
    display: none;
    margin-top: var(--spacing-05);
    /*padding: 10px;*/
    min-width: 200px;
    box-shadow: var(--shadow-light);
}

/*:host(:not([message])) .timepicker-panel {*/
/*    top: 64px;*/
/*}*/

:host(:not([message])) .swiftref-input swiftref-message {
    margin-top: 0;
    display: none;
}

.timepicker-panel.open {
    display: block;
}

.time-selectors {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: var(--spacing-05);
    padding: var(--spacing-10) 0;
}

.time-column {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 var(--spacing-05);
    gap: var(--spacing-05);
}

/* =============================================================================
    inputs
    ==========================================================================*/
.hour-selector, .minute-selector, .second-selector {
    display: flex;
    justify-content: center;
    align-items: center;
    width: var(--spacing-30);
    height: var(--spacing-40);
    margin: 4px 0;
    user-select: none;
    cursor: pointer;

    border: 1px solid var(--border-strong);
    border-radius: var(--spacing-05);
    padding: var(--spacing-05) var(--spacing-10);

    transform: scale(1);
    transition: scale 0.3s ease;
}
.hour-selector:hover, .minute-selector:hover, .second-selector:hover {
    transform: scale(1.05);
    backdrop-filter: blur(4px);
}

.hour-selector:focus, .minute-selector:focus, .second-selector:focus {
    outline: 1px solid var(--border-focused);
}

.time-separator {
    margin: 0 2px;
    align-self: center;
}

.ampm-selector {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50px;
    height: 40px;
    font-size: 16px;
    border: 1px solid var(--border-light);
    border-radius: 4px;
    cursor: pointer;
    background: none;
    margin: 5px 0;
}

.ampm-selector:focus {
    outline: none;
}

.panel-footer {
    padding: 8px;
    border-top: 1px solid var(--border-light);
    display: flex;
    justify-content: space-between;
}


/*  ============================================================================
    headless mode (used inside the date component)
    ==========================================================================*/
:host([headless]) .swiftref-input {
    display: none;
}
:host([headless]) .timepicker-panel {
    box-shadow: none;
    border: none;
    display: block;
    position: static;
}
:host([headless]) .time-selectors {
    padding: 0;
}

:host([headless]) .panel-footer {
    display: none;
}



`, "",{"version":3,"sources":["webpack://./../website_design_system/src/components/form/time/style/index.css"],"names":[],"mappings":"AAGA;;+EAE+E;AAC/E;IACI,kBAAkB;IAClB,kCAAkC;IAClC,wBAAwB;IACxB,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,wBAAwB;AAC5B;AACA,2DAA2D;AAC3D,qBAAqB;AACrB,qBAAqB;AACrB,IAAI;;;AAGJ;;+EAE+E;;AAE/E;IACI,qBAAqB;IACrB,gGAAgG;IAChG,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;;AAGA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,qCAAqC;IACrC,qCAAqC;IACrC,kBAAkB;IAClB,aAAa;IACb,6BAA6B;IAC7B,iBAAiB;IACjB,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA,6CAA6C;AAC7C,iBAAiB;AACjB,IAAI;;AAEJ;IACI,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,4BAA4B;IAC5B,sBAAsB;AAC1B;;AAEA;;+EAE+E;AAC/E;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,wBAAwB;IACxB,yBAAyB;IACzB,aAAa;IACb,iBAAiB;IACjB,eAAe;;IAEf,sCAAsC;IACtC,gCAAgC;IAChC,4CAA4C;;IAE5C,mBAAmB;IACnB,2BAA2B;AAC/B;AACA;IACI,sBAAsB;IACtB,0BAA0B;AAC9B;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,qCAAqC;IACrC,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,yCAAyC;IACzC,aAAa;IACb,8BAA8B;AAClC;;;AAGA;;+EAE+E;AAC/E;IACI,aAAa;AACjB;AACA;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;AACjB","sourcesContent":["@import '../../input/style/index.css';\n@import '../../common_style/arrow_button.css';\n\n/* =============================================================================\n    overwrite base input style\n   ===========================================================================*/\n.swiftref-input swiftref-icon {\n    position: absolute;\n    top: calc(var(--spacing-15) + 1px);\n    right: var(--spacing-10);\n    left: unset;\n    width: fit-content;\n}\n.swiftref-input .clear-icon {\n    right: var(--spacing-30);\n}\n/*:host(:not([message]) .swiftref-input swiftref-message {*/\n/*    margin-top: 0;*/\n/*    display: none;*/\n/*}*/\n\n\n/* =============================================================================\n    time_input style\n   ===========================================================================*/\n\n:host {\n    display: inline-block;\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\n    position: relative;\n}\n\n.timepicker-container {\n    position: relative;\n}\n\n\n.timepicker-panel {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    z-index: 10;\n    background: var(--background-default);\n    border: 1px solid var(--border-light);\n    border-radius: 4px;\n    display: none;\n    margin-top: var(--spacing-05);\n    /*padding: 10px;*/\n    min-width: 200px;\n    box-shadow: var(--shadow-light);\n}\n\n/*:host(:not([message])) .timepicker-panel {*/\n/*    top: 64px;*/\n/*}*/\n\n:host(:not([message])) .swiftref-input swiftref-message {\n    margin-top: 0;\n    display: none;\n}\n\n.timepicker-panel.open {\n    display: block;\n}\n\n.time-selectors {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: var(--spacing-05);\n    padding: var(--spacing-10) 0;\n}\n\n.time-column {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 0 var(--spacing-05);\n    gap: var(--spacing-05);\n}\n\n/* =============================================================================\n    inputs\n    ==========================================================================*/\n.hour-selector, .minute-selector, .second-selector {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: var(--spacing-30);\n    height: var(--spacing-40);\n    margin: 4px 0;\n    user-select: none;\n    cursor: pointer;\n\n    border: 1px solid var(--border-strong);\n    border-radius: var(--spacing-05);\n    padding: var(--spacing-05) var(--spacing-10);\n\n    transform: scale(1);\n    transition: scale 0.3s ease;\n}\n.hour-selector:hover, .minute-selector:hover, .second-selector:hover {\n    transform: scale(1.05);\n    backdrop-filter: blur(4px);\n}\n\n.hour-selector:focus, .minute-selector:focus, .second-selector:focus {\n    outline: 1px solid var(--border-focused);\n}\n\n.time-separator {\n    margin: 0 2px;\n    align-self: center;\n}\n\n.ampm-selector {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 50px;\n    height: 40px;\n    font-size: 16px;\n    border: 1px solid var(--border-light);\n    border-radius: 4px;\n    cursor: pointer;\n    background: none;\n    margin: 5px 0;\n}\n\n.ampm-selector:focus {\n    outline: none;\n}\n\n.panel-footer {\n    padding: 8px;\n    border-top: 1px solid var(--border-light);\n    display: flex;\n    justify-content: space-between;\n}\n\n\n/*  ============================================================================\n    headless mode (used inside the date component)\n    ==========================================================================*/\n:host([headless]) .swiftref-input {\n    display: none;\n}\n:host([headless]) .timepicker-panel {\n    box-shadow: none;\n    border: none;\n    display: block;\n    position: static;\n}\n:host([headless]) .time-selectors {\n    padding: 0;\n}\n\n:host([headless]) .panel-footer {\n    display: none;\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
